import { Injectable } from '@angular/core'
import { UtilService } from './util.service'
import { GlobService } from './glob.service'
import { AlerterService } from './alerter.service'

@Injectable({
  providedIn: 'root'
})
export class AjaxService {

  //-- need to proccess -----------------------------
  // Count: number = 4 // max of execute
  // when: string = 'later'  // 'now', 'later'
  // list: any = []

  // // domain: string = this.glob.domain
  // url: string = this.glob.url
  // host: string = this.glob.host
  cache = new Array();
  thos = this

  constructor(private glob: GlobService, private util: UtilService, private alerter: AlerterService) {

  }

  execute(option) {
    option = this.repair(option);

    if (option.disable != undefined) option.disable.prop('disabled', true); // jquery dom object
    if (option.loading != undefined) option.loading.css('visibility', 'visible'); // jquery dom object
    if (option.alertPad != undefined && option.alertPad.append != undefined && (option.alertPad.pad != 'toastr' && option.alertPad.pad != 'console') && !option.alertPad.append) option.alertPad.pad.html('');

    // if (dmode == 'debug') {
    // console.log('ajax (send): ' + (option.cache == true && this.Cache.Has(option.url + '?' + option.dataString) ? 'cache ' : 'nocache ') + option.url + (option.queryString == '' ? '' : ('?' + option.queryString)));
    // console.log(option.data);
    // }

    // ----- execute ----------------------------
    if (false && option.cache == true && this.cache_has(this.glob.url + '?' + option.dataString)) {
      var post = this.cache_content(option.url + '?' + option.dataString)
      post.cache = true
      option.success(post, this)
      option.complete()
    }
    else {
      // console.log('ajax data: ' + option.url + (option.queryString == '' ? '' : ('?' + option.queryString)), option.data)
      $.ajax({
        url: option.url + (option.queryString == '' ? '' : ((option.url.indexOf('?') == -1 ? '?' : '') + option.queryString)),
        data: option.data,
        cache: option.cache,
        type: option.type,
        dataType: option.dataType,
        contentType: option.contentType,
        processData: option.processData,
        success: option.success,
        complete: option.complete,
        error: option.error,
        xhrFields: { withCredentials: true }
      })
    }
  }

  execute_partial(option: any) {
    var where = option.whereId == undefined ? $('#contentPart') : $('#' + option.whereId);
    var thos = this

    where.fadeOut(500, function () {
      where.html('loading...');
      where.show();

      thos.execute({
        url: option.url,
        queryString: option.queryString,
        type: 'GET',
        dataType: 'html',
        success: function (result: any) {
          where.hide();
          where.html(result);

          setTimeout(function () {
            //np RegisterValidation(option.whereId);
            where.fadeIn(400);
            if (option.complete != undefined) option.complete();
            if (option.success != undefined) option.success();
          }, 700)
        }
      });
    });
  }

  repair(option): any {
    var url: string = option.url.indexOf('http') == -1 ? this.glob.host + option.url : option.url
    var queryString: string = option.queryString == undefined ? '' : option.queryString
    var dataString: string = (option.data == undefined) ? '' : JSON.stringify(option.data)
    var data: any = option.data == undefined ? '' : option.data
    var type: string = option.type == undefined ? 'GET' : option.type
    var auth: boolean = option.auth == undefined ? true : option.auth
    var dataType: string = option.dataType == undefined ? 'json' : option.dataType
    var contentType: string = option.contentType == undefined ? 'application/x-www-form-urlencoded; charset=UTF-8' : option.contentType
    var processData: any = option.processData == undefined ? true : option.processData
    var cache: any = option.cache == undefined ? false : option.cache
    var alertPad: any = {}
    let thos = this.thos

    if (option.alertPad != undefined) {
      if (option.alertPad.pad) {
        if (!option.alertPad.mode) option.alertPad.mode = 'ctext'
        if (!option.alertPad.append) option.alertPad.append = true
        if (!option.alertPad.display) option.alertPad.display = 'inline-block'
        alertPad = option.alertPad
      }
      else
        alertPad = option.alertPad = { pad: 'toastr', mode: 'text', append: true }
    }
    else if (option.form != undefined && option.form.find('.alertPad:first') != undefined) {
      alertPad = option.alertPad = { pad: option.form.find('.alertPad:first'), mode: 'alert', append: false }
    }
    else alertPad = option.alertPad = { pad: 'toastr', mode: 'pure', append: false }

    var success = (post) => {
      if (dataType == 'json') {
        if (alertPad == undefined) {
          // this.alerter.warning('AlertPad is undefined please recheck the ajax.js')
          this.alerter.warning('AlertPad is undefined please recheck the ajax.js')
          return
        }

        if (!post.stime) {
          this.alerter.warning('ساختار درخواست صحیح نیست')
        }

        // --- if non-authenticate go to login --------------
        for (let x of post.alerts)
          if (x.t == 4) {
            window.location.href = 'account/login' // base/index
            return
          }

        // --- cleare the pad ----------------------
        if (!alertPad.append && alertPad.pad != 'toastr' && alertPad.pad != 'console')
          if (alertPad.pad.length == 1 && alertPad.pad[0].tagName != undefined) // is dom element
            alertPad.pad.html('');
          else if (alertPad.pad != 'toastr' && alertPad.pad != 'console') // array
            alertPad.pad.length = 0;

        // --- format alerts -----------------------
        for (var i = 0; i < post.alerts.length; i++) {
          if (alertPad.mode == 'alert')
            post.alerts[i].m = '<p class="alert alert-' + this.switch_alert(post.alerts[i].t) + ' alert-dismissable" style="margin-bottom:2px; padding-top:10px; padding-bottom:10px; display:' + alertPad.display + '"><a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a> &nbsp &nbsp' + post.alerts[i].m + '</p>';
          else if (alertPad.mode == 'ctext')
            post.alerts[i].m = '<span class="' + this.switch_color(post.alerts[i].t) + '" style="display:' + alertPad.display + '">• ' + post.alerts[i].m + ' &nbsp; &nbsp; </span>';
          else if (alertPad.mode == 'text')
            post.alerts[i].m = '<span style="display:' + alertPad.display + '">• ' + post.alerts[i].m + ' &nbsp; &nbsp; </span>';

          if (this.glob.dmode && i == 0 && alertPad.pad.length == 1 && alertPad.pad[0].tagName != undefined) {
            alertPad.pad.append((alertPad.display == 'inline-block' ? '<br />' : '') + '<span style="display:' + alertPad.display + '">[ ' + post.stime + ' --- ' + post.etime + ' ] &nbsp; &nbsp; </span>');
          }

          if (alertPad.pad == 'toastr') {
            switch (post.alerts[i].t) {
              case 0: this.alerter.error(post.alerts[i].m); break;
              case 1: this.alerter.warning(post.alerts[i].m); break;
              case 2: this.alerter.success(post.alerts[i].m); break;
              case 3: this.alerter.info(post.alerts[i].m); break;
              case 4: window.location.href = '/account/login'
            }
          }
          else if (alertPad.pad.length == 1 && alertPad.pad[0].tagName != undefined) // is dom element
            alertPad.pad.append(post.alerts[i].m);

          if (post.alerts[i].sql) console.log('alert: ', post.alerts[i])
        }

        if (alertPad.pad != 'toastr' && alertPad.pad != 'console' && !(alertPad.pad.length == 1 && alertPad.pad[0].tagName != undefined)) // is array variable
          alertPad.pad.push({ alerts: post.alerts, start: post.stime, end: post.etime });

        var hasError = false;
        for (let x of post.alerts)
          if (x.t == 0 || x.t == 1)
            hasError = true
        if (hasError) {
          if (this.glob.dmode) {
            console.log('ajax (receive with error): ' + post.stime + '-' + post.etime + ' ' + option.url + (option.queryString == undefined ? '' : ('?' + option.queryString)));
            console.log(post);
          }
          return;
        }

        // if (dmode == 'debug') {
        //     console.log('ajax (receive): ' + post.stime + '-' + post.etime + ' ' + option.url + (option.queryString == undefined ? '' : ('?' + option.queryString)));
        //     console.log(post);
        // }

        if (option.success) { option.success(post); }
        if (option.cache == true) this.cache_add(url + '?' + dataString, post);
        if (option.callback) option.callback(post);
      }
      else if (dataType == 'file') {
        console.log('the file')
      }
      else { // dataType == html or string
        option.success(post);
        if (option.cache == true) this.cache_add(url + '?' + dataString, post);
        if (option.callback != undefined) option.callback(post);
      }
      //$(document).trigger(option.url, post);
    }

    var complete = (post) => {
      if (this.glob.dmode && post.responseJSON.struct) {
        this.alerter.info(JSON.stringify(post.responseJSON.struct, undefined, 2))
      }
      if (option.disable != undefined) option.disable.prop('disabled', false)
      if (option.loading != undefined) option.loading.css('visibility', 'hidden')

      if (option.complete != undefined) option.complete(post, post.responseJSON)
    }

    var error = (jqXHR, exception) => {
      console.log(700, 'jqXHR', jqXHR)
      console.log(700, 'exception', exception)
      var res = thos.error_message(jqXHR, exception, 'client: ' + (option.address != undefined ? option.address : '---') + '\n server: ' + option.url)
      // window.document.write(jqXHR.responseText)
      if(res.indexOf('یا زمان آن منقضی')!=-1)thos.alerter.info(res)
      else thos.alerter.error(res)
      //Cmodal.Document('خطای ارسال', jqXHR.responseText, '95%')
      //Cmodal.body.find('style').remove()
      //Cmodal.Open()
    };

    return {
      url: url,
      data: data,
      type: type,
      dataType: dataType,
      success: success,
      complete: complete,
      error: error,
      alertPad: option.alertPad,
      dataString: dataString,
      queryString: queryString,
      cache: cache,
      disable: option.disable,
      contentType: contentType,
      processData: processData,
      loading: option.loading
    }
  }

  load_script(url) {
    url = url.indexOf('http') == -1 ? this.glob.domain + url : url
    let body = <HTMLDivElement>document.body;
    let script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = true;
    script.defer = true;
    body.appendChild(script);
  }


  // ----- catching --------------------------------------
  cache_add(URL, Content) {
    this.cache.push({ url: URL, content: Content });
  }

  cache_content(url) {
    for (var i = 0; i < this.cache.length; i++)
      if (url == this.cache[i].url) { return this.cache[i].content };

    return 'not found';
  }

  cache_has(url) {
    for (var i = 0; i < this.cache.length; i++)
      if (url == this.cache[i].url) return true

    return false;
  }

  cache_clear() {
    this.cache = []
  }


  // ----- utility ----------------------------------------
  switch_alert(type: any) {
    switch (type) {
      case '0': case 0: return 'danger'; break;
      case '1': case 1: return 'warning'; break;
      case '2': case 2: return 'success'; break;
      case '3': case 3: return 'info'; break;
      default: return type
    }
  }

  switch_color(type: any) {
    switch (type) {
      case '0': case 0: return 'red'; break;
      case '1': case 1: return 'orange'; break;
      case '2': case 2: return 'green'; break;
      case '3': case 3: return 'blue'; break;
      default: return type
    }
  }

  error_message(jqXHR: any, exception: any, own: any) {
    var Result = '' // own + '\n';

    if (jqXHR.status === 0) { Result += 'Not connect. Verify Network.'; }
    else if (jqXHR.status == 401) { Result += 'مجوز ورود معتبر نیست یا زمان آن منقضی شده است. لطفا مجددا وارد سامانه شوید'; setTimeout(() => { window.location.href = 'account/login'  }, 2000); }
    else if (jqXHR.status == 404) { Result += 'Requested page not found. [404]'; }
    else if (jqXHR.status == 500) { Result += 'Internal Server Error [500].'; }
    else if (exception === 'parsererror') { Result += 'Requested JSON parse failed.'; }
    else if (exception === 'timeout') { Result += 'Time out error.'; }
    else if (exception === 'abort') { Result += 'ajax request aborted.'; }
    else { Result += 'Uncaught Error.\n' + jqXHR.responseText; }

    return Result;
  }
}
